/**
* Filter posts by taxonomy - voproperty
*/

( function( $ ) {
	let ajaxLock = false;

	$('#filter-vomunicipality').change(function() {
		ajaxFilterPostTypeByTerm( $(this).val(), $(this).data('voproperty') );
	});

	const ajaxFilterPostTypeByTerm = (term_id, slug) => {
		ajaxLock = true;

		console.log(parseInt(term_id));
		console.log(slug);

		$.ajax({
			method: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'json',
			data: {
				action: 'filter_option_result',
				term_id: term_id,
				slug: slug,
			}
		})
		.done(function(response) {
			// This will reset the archive
			if ( 0 == parseInt(term_id) ) {
				window.location.reload(true);
				return;
			}

			if ( 'none' == slug ) {
				$('.estate-online__archive .main-archive').empty();
				$('.estate-online__archive .main-archive').append(response.content);
			}

			if ( 'none' != slug ) {
				$(`.estate-online__archive .${slug}`).empty();
				$(`.estate-online__archive .${slug}`).append(response.content);
			}

			ajaxLock = false;
			console.log(response);
			console.log( 'Success' );
		})
		.fail(function(jqXHR, textStatus, errorThrown) {
			ajaxLock = false;

			console.log(XMLHttpRequest);
			console.log(textStatus);
			console.log(errorThrown);

			console.log( 'Failed' );
		});
	}

})(jQuery);
